export default __webpack_public_path__ + "static/media/chrome-desktop-1.a7432f2d.png";